"use client";

import { c as _c } from "react/compiler-runtime";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import { Checkbox, Tooltip } from "@/components/ui";
import { TableHead, TableHeaderCell, TableHeaderRow } from "@/components/ui/table";
import { handleSortChange } from "@/lib/table";
import { cx } from "@/lib/tailwind-utils";
import { PageParams } from "@/types/pagination";
export interface SortableHeader {
  label: string;
  sortField: string;
  className?: string;
  style?: React.CSSProperties;
  unfilterable?: boolean;
  tooltip?: string;
}
type SelectState = "none" | "all" | "indeterminate";
interface SortableTableHeadProps<T extends PageParams> {
  headers: SortableHeader[];
  filters: T;
  setFilters: (update: T | ((prevFilters: T) => T)) => void;
  className?: string;
  selectable?: boolean;
  selectState?: SelectState;
  onSelectAll?: (checked: boolean) => void;
}
export function SortableTableHead(t0) {
  const $ = _c(17);
  const {
    headers,
    filters,
    setFilters,
    className,
    selectable,
    selectState: t1,
    onSelectAll
  } = t0;
  const selectState = t1 === undefined ? "none" : t1;
  const checkboxChecked = selectState === "all" ? true : selectState === "indeterminate" ? "indeterminate" : false;
  let t2;
  if ($[0] !== checkboxChecked || $[1] !== onSelectAll || $[2] !== selectable) {
    t2 = selectable && <TableHeaderCell className="w-[40px]"><Checkbox checked={checkboxChecked} onCheckedChange={checked => onSelectAll?.(!!checked)} aria-label="Select all" /></TableHeaderCell>;
    $[0] = checkboxChecked;
    $[1] = onSelectAll;
    $[2] = selectable;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== filters || $[5] !== headers || $[6] !== setFilters) {
    let t4;
    if ($[8] !== filters || $[9] !== setFilters) {
      t4 = h => {
        const shouldWrap = h.label.length > 18 || h.className?.includes("line-clamp");
        return <TableHeaderCell key={h.label} className={cx("py-3 text-foreground-secondary", h.sortField !== "none" ? "cursor-pointer" : "cursor-default", shouldWrap && "overflow-hidden whitespace-normal", h.className)} style={h.style} onClick={() => h.sortField !== "none" && handleSortChange(h.sortField, filters, setFilters)}>{h.tooltip ? <Tooltip content={h.tooltip}><div className={cx("flex items-center gap-1", h.className?.includes("text-right") && "justify-end")}><span className={cx(shouldWrap ? "line-clamp-2 text-xs" : "truncate text-sm")}>{h.label}</span><BsFillQuestionCircleFill size={14} className="shrink-0 text-foreground-muted" />{h.sortField !== "none" && <div className="ml-1 flex flex-col"><TiArrowSortedUp className={cx("h-3 w-3", {
                  "text-primary": filters.sortBy === h.sortField && filters.sortDirection === "asc",
                  "text-gray-300 dark:text-gray-600": filters.sortBy !== h.sortField || filters.sortDirection !== "asc"
                })} /><TiArrowSortedDown className={cx("-mt-1 h-3 w-3", {
                  "text-primary": filters.sortBy === h.sortField && filters.sortDirection === "desc",
                  "text-gray-300 dark:text-gray-600": filters.sortBy !== h.sortField || filters.sortDirection !== "desc"
                })} /></div>}</div></Tooltip> : <div className={cx("flex gap-1", shouldWrap ? "items-start" : "items-center", h.className?.includes("text-right") && "justify-end")}><span className={cx(shouldWrap ? "line-clamp-2 text-xs" : "truncate text-sm")}>{h.label}</span>{h.sortField !== "none" && <div className="ml-1 flex flex-col shrink-0"><TiArrowSortedUp className={cx("h-3 w-3", {
                "text-primary": filters.sortBy === h.sortField && filters.sortDirection === "asc",
                "text-gray-300 dark:text-gray-600": filters.sortBy !== h.sortField || filters.sortDirection !== "asc"
              })} /><TiArrowSortedDown className={cx("-mt-1 h-3 w-3", {
                "text-primary": filters.sortBy === h.sortField && filters.sortDirection === "desc",
                "text-gray-300 dark:text-gray-600": filters.sortBy !== h.sortField || filters.sortDirection !== "desc"
              })} /></div>}</div>}</TableHeaderCell>;
      };
      $[8] = filters;
      $[9] = setFilters;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = headers.map(t4);
    $[4] = filters;
    $[5] = headers;
    $[6] = setFilters;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <TableHeaderRow>{t2}{t3}</TableHeaderRow>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== className || $[15] !== t4) {
    t5 = <TableHead className={className}>{t4}</TableHead>;
    $[14] = className;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}